<template>
  <v-container fluid>
    <ValidationObserver
      tag="div"
      ref="observer"
      v-slot="{ handleSubmit, invalid }"
      class="width100"
    >
      <form
        @submit.prevent="handleSubmit(onSubmitHandler)"
        v-if="ForgotPasswordForm"
      >
        <v-container>
          <!-- Logo -->
          <v-col cols="12">
            <v-img src="/logo.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <!-- Logo text-->
          <v-col cols="12">
            <v-img src="/LogoText.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <v-row justify="center">
            <!-- Inputs -->
            <v-col cols="10">
              <ValidationProvider
                class="width100"
                rules="required|password:@confirm"
                mode="eager"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="password"
                  v-model="password"
                  :label="labels.enterPassword"
                  solo
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                name="confirm"
                rules="required"
                mode="eager"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="confirmPass"
                  type="password"
                  :label="labels.confirmPassword"
                  solo
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
              <!-- // Inputs -->
              <!-- Submit button -->
              <v-row justify="end" class="mx-0 my-5">
                <v-btn
                  small
                  color="white"
                  class="font-weight-light"
                  @click="submitForgotPasswordForm"
                  id="reset_pass_btn"
                  >{{ labels.submit }}</v-btn
                >
              </v-row>
              <!-- // Submit button -->
            </v-col>
          </v-row>
        </v-container>
      </form>

      <form v-else>
        <v-container>
          <v-col cols="12">
            <v-img src="/logo.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <!-- Logo text-->
          <v-col cols="12">
            <v-img src="/LogoText.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <!-- Inputi -->
          <v-row justify="center">
            <v-col cols="10">
              <ValidationProvider
                class="width100"
                name="confirm"
                rules="required|email"
                mode="eager"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="email"
                  :label="labels.enterEmail"
                  required
                  solo
                  dense
                  hide-details="auto"
                  class="mb-2"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>

              <!-- Btn group -->
              <v-row justify="space-between" class="mx-0 my-5">
                <v-btn
                  small
                  color="white"
                  class="font-weight-light"
                  @click="$router.go(-1)"
                >
                  <v-icon left> mdi-arrow-left </v-icon>
                  {{ labels.back }}
                </v-btn>
                <v-btn
                  small
                  color="white"
                  class="font-weight-light"
                  @click="submitEmailForm"
                  id="submit_email_btn"
                  >{{ labels.submit }}</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
          <!-- // Inputi -->
        </v-container>
      </form>
    </ValidationObserver>
    <v-snackbar
      v-model="showDismissibleAlert"
      timeout="-1"
      right
      :color="notificationType"
    >
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="#fff"
          text
          v-bind="attrs"
          @click="showDismissibleAlert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import store from '@/store/store'
import translate from '@/utils/genTable/multilanguageHelper.js'
import axios from 'axios'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: translate('Password confirmation does not match', 'validations')
})

extend('email', {
  ...email,
  message: translate('Please type valid email address', 'validations')
})
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      email: '',
      password: '',
      confirmPass: '',
      token: null,
      ForgotPasswordForm: false,
      notification: null,
      showDismissibleAlert: false,
      notificationType: null,
      labels: {
        submit: translate('Submit', 'pages.forgotPassword'),
        email: translate('Email', 'pages.forgotPassword'),
        back: translate('Back', 'pages.forgotPassword'),
        enterEmail: translate(
          'Please enter your email',
          'pages.forgotPassword'
        ),
        enterPassword: translate(
          'Please enter your pasword',
          'pages.forgotPassword'
        ),
        confirmPassword: translate(
          'Please confirm your password',
          'pages.forgotPassword'
        ),
        successfullEmailNotification: translate(
          'Mail has been sent.',
          'pages.forgotPassword'
        ),
        unSuccessfullEmailNotification: translate(
          'Something went wrong, please contact the administrator.',
          'pages.forgotPassword'
        ),
        successfullPasswordChange: translate(
          'Password changed  successfully.',
          'pages.forgotPassword'
        )
      }
    }
  },
  computed: {
    bPoint() {
      return this.$vuetify.breakpoint
    }
  },
  mounted() {
    this.ForgotPasswordForm = this.isForgotPasswordForm()
  },
  methods: {
    submitEmailForm() {
      var self = this
      axios
        .post('https://prod-back.olymo.net/api/ForgetPassword', {
          data: [
            {
              email: `${this.email}`,
              app: 'vozila'
            }
          ]
        })
        .then(function(response) {
          if (response.status == 200) {
            self.displayNotification(
              `An email has been sent to ${self.email} with instructions.`,
              'success'
            )
          } else {
            self.displayNotification(
              self.labels.unSuccessfullEmailNotification,
              'error'
            )
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            store.dispatch(
              'notification/add',
              {
                type: 'error',
                message: translate(
                  'The provided email address doesnt exist in the system',
                  'pages.forgotPassword'
                )
              },
              {
                root: true
              }
            )
          } else {
            store.dispatch(
              'notification/add',
              {
                type: 'error',
                message: translate(
                  'Server error, call your administrator',
                  'pages.forgotPassword'
                )
              },
              {
                root: true
              }
            )
          }
        })
    },
    isForgotPasswordForm() {
      let token = window.location.href.split('=')[1]
      if (token !== undefined) {
        this.token = token
        return true
      }
      return false
    },
    submitForgotPasswordForm() {
      var self = this
      axios
        .post('https://prod-back.olymo.net/api/new-password', {
          data: [
            {
              q: `${this.token}`,
              password: this.password
            }
          ]
        })
        .then(function(response) {
          if (response.status == 200) {
            self.displayNotification(
              self.labels.successfullPasswordChange,
              'success'
            )
          }
        })
        .catch(function(error) {
          store.dispatch(
            'notification/add',
            {
              type: 'error',
              message: translate(
                'Server error, call your administrator',
                'pages.forgotPassword'
              )
            },
            {
              root: true
            }
          )
        })
      setTimeout(() => {
        this.$router.push('/login')
      }, 3000)
    },
    displayNotification(notification, type) {
      this.showDismissibleAlert = true
      this.notification = notification
      this.notificationType = type
    }
  }
}
</script>

<style scoped>
.width100 {
  width: 100%;
}
.clearColumnPadding {
  padding: 0px;
}
</style>
